<template>
  <div>
    <el-container style="width: 900px;margin: 0 auto;">
      <el-header style="margin: 0 auto;" v-if="isCollapse">
        <div style="display: flex;justify-content: space-between;width: 800px">
          <el-menu router :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="selectMenu"
          >
            <el-menu-item  index="1-1" route="/main/price/priceHome">
              <span slot="title">报价器</span>
            </el-menu-item>
<!--            <el-menu-item  index="1-2" route="/main/msg">-->
<!--              <span slot="title">小信鸽</span>-->
<!--            </el-menu-item>-->
                        <el-menu-item class="tatas"  index="1-4" route="/main/notices">
                          <el-badge :hidden="noticeValue<=0" :value="noticeValue" >
                            <span >通知</span>
                          </el-badge>
                        </el-menu-item>
            <el-menu-item  index="1-3" route="/main/set">
              <span slot="title">设置</span>
            </el-menu-item>
          </el-menu>
          <div >
            <span  style="font-size: 10px;color: #303133;line-height: 60px">{{user.name}} &nbsp; ({{user.companyName}})</span>

            <el-link style="margin-left: 10px" type="primary" @click="onReload">刷新</el-link>
            <el-link  style="margin-left: 10px"  type="primary" @click="onClose">退出</el-link>
            {{reversedMessage}}
          </div>
        </div>
      </el-header>
      <el-container>
        <el-main>

          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
  import localforage from 'localforage'
  export default {
    name: 'AppMain',
    data () {
      return {
        isCollapse: true,
        leftHidden: false,
        defaultPriceUrl:'',
        user:{},
      }
    },
    watch:{
      noticeValue:function(){
      this.noticeValue=this.$store.state.noticeValue
      }
    },
    created(){
    },
    mounted(){
       localforage.getItem('noticeValue').then(res=>{
         this.$store.commit('SET_NOTICEVALUE',res)
         let user= sessionStorage.getItem('user')
         if(user!=null){
           this.user=JSON.parse(user)
         }
         this.sysNotify()
       })
       this.initLoading()
    },
    computed: {
 
  
      activeIndex () {
        return sessionStorage.getItem('activeIndex')
      },
      noticeValue:function(){
        return this.$store.state.noticeValue
      },
    },
    methods: {
      isPc(){
        console.log(window.navigator.userAgent)
            if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
              return true; // 移动端
            }else{
              return false; // PC端
            }
        },
      initLoading(){
        let scren_width=window.screen.width
        let scren_height=window.screen.height
        console.log(scren_width,scren_height)
        if(scren_width<600){
          this.isCollapse=false
        }
      },
      selectMenu (index, indexPath) {
        sessionStorage.setItem('activeIndex',index)
        if (index=='1-2'){
          if (this.$store.getters.socket==null){
            this.$store.commit('SOCKET_CONNECTION')
          }
        }
      },
      onClose () {
        this.$store.commit('WEB_DB', null)
        this.$store.commit('SET_SESSIONS', [])
        this.$store.commit('SET_SESSION', {})
        localStorage.removeItem('token')
        sessionStorage.removeItem('user')
        sessionStorage.removeItem('activeIndex')
        this.$router.push({ name: 'login' })
        this.$store.dispatch('socketClose')
      },
      onReload(){
        location.reload();
      },
      sysNotify() {
        if(this.isNotice==true)
        {
          return
        }
        let para={
          pageIndex:1,
          pageSize:10
        }
        this.$http.get('/api/user/notices',{params:para}).then(res=>{

          if(res!=null){
            let data=res.data
            let dicValue= 0
            localforage.getItem('notices').then(old=>{
              if(old!=null){
                dicValue=data.length-this.findObj(data,old)
                if(dicValue!=null){
                  this.$store.commit('SET_NOTICEVALUE',dicValue)
                  localforage.setItem('noticeValue',dicValue)
                }
              }else{
                this.$store.commit('SET_NOTICEVALUE',data.length)
                localforage.setItem('noticeValue',data.length)
              }
            })
          }
        })
      },
      findObj(newArr,oldArr){
        let noticeValue=0
        if(newArr!=null && oldArr!=null){
          newArr.forEach(newItem=>{
            oldArr.forEach(oldItem=>{
              if(newItem.ID==oldItem.ID){
                noticeValue++
              }
            })
          })
        }
        return noticeValue
      },
      goNotices(){
        this.$router.push({ name: 'notices' })
      }
    },
  }
</script>

<style scoped>
  /deep/ .tatas .el-badge__content.is-fixed{
    top:18px !important;
  }
</style>
<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    min-height: 400px;
    text-align: center;
  }

</style>
